import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CheckupService } from '../../../services/saude/checkup.service';
@Component({
  selector: 'app-checkup',
  templateUrl: './checkup.component.html',
  styleUrls: ['./checkup.component.css']
})
export class CheckupComponent {
  loadingCosts: any = false;
  errorCosts: boolean = false;
  beneficiarios: any;
  constructor(private checkUp: CheckupService, private toast: ToastrService) {
    this.loadingCosts = !this.loadingCosts;
    this.checkUp.getCheckUps().subscribe({
      next: res => {
        this.beneficiarios = res;
        this.loadingCosts = !this.loadingCosts;
      },
      error: erro => {
        this.toast.error("Sem conexão com o servidor, por favor tentar mais tarde!");
        this.loadingCosts = !this.loadingCosts;
      },
    })
  }
  generatePDF(cpf: any) {
    this.checkUp.generatePDF(cpf).subscribe(
      (data) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Guias-" + cpf + ".pdf";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    )
  }
}
